"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.listGroupMembers = exports.queryNonGroupMembers = exports.queryGroupMembers = exports.getGroupMember = exports.getMember = void 0;
const constants_1 = require("../constants");
function getMember({ memberId, }) {
    return {
        method: 'GET',
        url: `/${constants_1.serverlessBaseURL}/group/members/${memberId}`,
    };
}
exports.getMember = getMember;
function getGroupMember({ groupId, memberId, }) {
    return {
        method: 'GET',
        url: `/${constants_1.serverlessBaseURL}/group/${groupId}/group-members/${memberId}`,
    };
}
exports.getGroupMember = getGroupMember;
function queryGroupMembers({ groupId, ...data }) {
    return {
        data,
        method: 'POST',
        url: `/${constants_1.serverlessBaseURL}/group/${groupId}/group-members/query`,
    };
}
exports.queryGroupMembers = queryGroupMembers;
function queryNonGroupMembers({ groupId, ...data }) {
    return {
        data,
        method: 'POST',
        url: `/${constants_1.serverlessBaseURL}/group/${groupId}/non-group-members/query`,
    };
}
exports.queryNonGroupMembers = queryNonGroupMembers;
function listGroupMembers({ groupId, limit, offset, }) {
    return {
        method: 'GET',
        params: {
            limit,
            offset,
        },
        url: `/${constants_1.serverlessBaseURL}/group/${groupId}/group-members`,
    };
}
exports.listGroupMembers = listGroupMembers;
//# sourceMappingURL=http.js.map